<template>
    <div class="map-area"  >
        <div id="container"></div>
        <div class="clear"></div>
        <div class="searchPart">
            <a-select
            showSearch
            placeholder="请输入"
            @search="inputChange"
            :disabled="disabled"
            >
                <a-button :disabled="disabled" slot="suffixIcon" class="mapbtn" type="primary" @click="searchKeyword">搜索</a-button>
                <a-select-option v-for="(item,index) in searchResultsLocation"  :key="index"  @click="searchChecked(item.latLng)" >{{item.name}}</a-select-option>
            </a-select>
        </div>
        <!-- <div style='width: 500px; height: 180px' id="infoDiv"></div> -->
    </div>
</template>
<script>

    /**
     * 腾讯地图搜索关键词选点组件
     * @prop {String} selectedCity 选择的城市
     * @prop {Object} checkedLatLng 列表所选择的地点的经纬度
     * @prop {String} keyword 搜索关键词
     *
     */
    export default {
        name: 'TMapComponent',
        zh: '腾讯地图搜索关键词选点组件',
        data() {
            return {
                searchService: [],//地图搜索服务
                markers: [],//地图标记点
                citylocation: null,
                searchLocation: "",//搜索的城市
                map: null,//绘制的地图
                keyword: '',//搜索关键词
                searchResultsLocation: null, //关键字搜索结果列表对象
                checkedLatLng: null, //列表所选择的地点的经纬度
            }
        },
        mounted() {
            this.initTmap()
        },
        props:{
            selectedCity:{type: String},//选择的城市
            disabled: {type:Boolean}
        },
        methods: {
            //初始化地图
            initTmap(){
                var self = this
                self.map = new qq.maps.Map(document.getElementById("container"), {
                    // 地图的中心地理坐标。
                    center: new qq.maps.LatLng(39, 116),
                    zoom: 10
                });
                //获取城市列表接口设置中心点
                self.citylocation = new qq.maps.CityService({
                    complete : function(result){
                        self.map.setCenter(result.detail.latLng);
                        self.searchLocation=result.detail.name
                    }
                });
                //调用searchLocalCity();方法    根据用户IP查询城市信息。
                self.citylocation.searchLocalCity();
            },
            //设置标记
            searchChecked(latLng){
                var self=this
                self.checkedLatLng = latLng
                self.clearOverlays(self.markers)
                var marker = new qq.maps.Marker({
                    map: this.map,
                    position: latLng
                });
                self.markers.push(marker);
                this.map.center=latLng;
                this.map.panTo(new qq.maps.LatLng(this.map.center.lat,this.map.center.lng));
                this.map.zoomTo(15);

                self.$emit("location", latLng) 
            },
            //清除标记
            clearOverlays(overlays) {
                var overlay;
                while (overlay = overlays.pop()) {
                    overlay.setMap(null);
                }
            },
            //地址输入框变化
            inputChange(val){
                this.keyword = val
            },
            //搜索关键字
            searchKeyword(){
                this.searchService.search(this.keyword);
            },
            allMap(){
                var self=this
                var latlngBounds = new qq.maps.LatLngBounds();
                //设置Poi检索服务，用于本地检索、周边检索
                self.searchService = new qq.maps.SearchService({
                    //设置搜索范围为北京
                    location: self.searchLocation,
                    //设置搜索页码为1
                    pageIndex: 0,
                    //设置每页的结果数为10
                    pageCapacity: 10,
                    //设置展现查询结构到infoDIV上
                    panel: document.getElementById('infoDiv'),
                    //设置动扩大检索区域。默认值true，会自动检索指定城市以外区域。
                    autoExtend: true,
                    //检索成功的回调函数
                    complete: function(results) {
                        self.searchResultsLocation = results.detail.pois;
                        //设置回调函数参数
                        var pois = results.detail.pois;
                        for (var i = 0, l = pois.length; i < l; i++) {
                            var poi = pois[i];
                            //扩展边界范围，用来包含搜索到的Poi点
                            latlngBounds.extend(poi.latLng);


                            var marker = new qq.maps.Marker({
                                map: self.map,
                                position: poi.latLng
                            });
                            self.markers.push(marker);
                        }
                        //调整地图视野
                        self.map.fitBounds(latlngBounds);
                    },
                    //若服务请求失败，则运行以下函数
                    error: function() {
                        self.$message.error('地图出错，请输入地址后搜索')
                    }
                });
            }
        },
        watch: {
            //监听选择的城市变化，改变搜索的城市
            selectedCity(selectLocation,old){
                this.searchLocation=selectLocation
            },
            //搜索的城市发生变化，重新设置地图接口的搜索的城市值
            'searchLocation'(val) {
                this.allMap()
            }
        }
    }
</script>
<style lang="scss">
#container {
    width: 100%;
    height: 400px;
    float: left;
}
.searchPart {
    position: absolute;
    left: 70px;
    top: 5px;
    width: 350px;

    .mapbtn {
        position: absolute;
        right: -12px;
        top: -10px;
    }
}
</style>